import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: ${theme.spacing.md};
`

export const Form = styled('form')`
  width: 100%;
  display: flex;
  gap: 12px;
  align-items: center;
  padding: ${theme.spacing.md} ${theme.spacing.xm};
  background-color: ${theme.colors.neutral.white};
  border-radius: 0 0 ${theme.shapes.borderRadius.xm} ${theme.shapes.borderRadius.xm};
  border-bottom: 1px ${theme.colors.neutral.clear};
`

export const Header = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.md} ${theme.spacing.xm};
  gap: ${theme.spacing.lg};
  background-color: ${theme.colors.neutral.white};
  border-radius: ${theme.shapes.borderRadius.xm} ${theme.shapes.borderRadius.xm} 0 0;
  border-bottom: solid 1px ${theme.colors.neutral.clear};
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.xs};
`

export const FileInput = styled.input`
  display: none;
`

export const ModalText = styled.span`
  font-size: ${theme.typography.sizes.xs};
  color: ${theme.colors.neutral[90]};
`
